module.exports = __webpack_public_path__ + "img/PPMP9.8da9d0d2.png";